var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWonRatio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 5.33333C9.99992 3.49239 8.50752 2 6.66659 2C4.82564 2 3.33325 3.49239 3.33325 5.33333C3.33325 7.17427 4.82564 8.66667 6.66659 8.66667C8.50752 8.66667 9.99992 7.17427 9.99992 5.33333Z",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3333C2 10.756 4.08934 8.66663 6.66667 8.66663C7.51667 8.66663 8.3136 8.89389 9 9.29096",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0697 9.67037L12.4803 10.4984C12.5363 10.6136 12.6857 10.7242 12.8116 10.7454L13.5559 10.87C14.0318 10.95 14.1438 11.2982 13.8009 11.6416L13.2223 12.225C13.1243 12.3238 13.0706 12.5144 13.1009 12.6508L13.2666 13.373C13.3973 13.9446 13.0963 14.1657 12.5947 13.867L11.8971 13.4506C11.7711 13.3753 11.5635 13.3753 11.4351 13.4506L10.7375 13.867C10.2383 14.1657 9.93494 13.9422 10.0656 13.373L10.2313 12.6508C10.2616 12.5144 10.2079 12.3238 10.1099 12.225L9.53134 11.6416C9.19067 11.2982 9.30034 10.95 9.77634 10.87L10.5205 10.7454C10.6442 10.7242 10.7935 10.6136 10.8495 10.4984L11.2601 9.67037C11.4841 9.22104 11.8481 9.22104 12.0697 9.67037Z",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWonRatio);
export default __webpack_public_path__ + "static/media/won-ratio.effc1cb125a5f75dcbccfe8f78263435.svg";
export { ForwardRef as ReactComponent };